import React from 'react';
import { createRoot } from 'react-dom/client';
import {
	createBrowserRouter,
	createRoutesFromElements,
	Route,
	RouterProvider,
	useRoutes,
} from "react-router-dom";
import AppRoute from './config/app-route.jsx';
import 'bootstrap/dist/css/bootstrap.min.css';

// bootstrap
import 'bootstrap';

// css
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './scss/react.scss';
import { store } from "./app/store.js";
import { Provider } from "react-redux";
import { ToastContainer, Slide } from 'react-toastify';


const container = document.getElementById('root');
const root = createRoot(container);

function AppRoutes() {
	return useRoutes(AppRoute);
}

function AppWithProviders() {
	return (
		<Provider store={store}>
			<ToastContainer
				position="top-right"
				autoClose={3000}
				hideProgressBar
				closeOnClick
				pauseOnHover
				draggable
				transition={Slide}
				icon={false}
				closeButton={false}
				toastClassName="serveiq-toast-wrapper"
				bodyClassName="serveiq-toast-body"
				style={{ zIndex: 99999 }}
			/>
			<AppRoutes />
		</Provider>
	);
}

const router = createBrowserRouter(
	createRoutesFromElements(<Route path="*" element={<AppWithProviders />} />)
);

root.render(<RouterProvider router={router} />);
